<div class="vh-100 m-3 d-flex w-100 flex-grow-1">
  <div class="d-flex flex-column flex-grow-1">
    <div>
      <span class="fs-4">{{ 'products' | translate }}</span>
      <hr />
    </div>
    <div class="card">
      <div class="card-header bg-secondary-subtle">
        <div class="d-flex">
          <button class="btn btn-light ms-auto" routerLink="/producten/aanmaken">
            <i class="bi bi-plus"></i>
          </button>
        </div>
      </div>
      <div class="card-body">
        <div class="input-group mb-3">
          <button class="btn btn-outline-secondary" (click)="loadProducts()">
            <i class="bi bi-search"></i>
          </button>
          <input type="text" [(ngModel)]="searchTerm" id="search" class="form-control" placeholder="{{ 'search_products' | translate }}" />
        </div>
        <table class="table">
          <thead>
            <tr>
              <th scope="col">{{ 'name' | translate }}</th>
              <th scope="col">{{ 'description' | translate }}</th>
              <th scope="col">{{ 'price' | translate }}</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <ng-container [formGroup]="formList">
              <ng-container formArrayName="productForms">
                @for (productForm of productForms.controls; track $index) {
                  @if (productForm.get('isEditing').value === false) {
                    <tr>
                      <td class="col-2 align-middle">{{ products[$index].listItem.name }}</td>
                      <td class="col-5 align-middle">{{ products[$index].listItem.description }}</td>
                      <td class="col-2 align-middle">€ {{ products[$index].listItem.price }}</td>
                      <td class="col-3 align-middle">
                        <div class="d-inline-block float-end">
                          <button class="btn btn-light me-1" (click)="editProduct($index)">
                            <i class="bi bi-pencil"></i>
                          </button>
                          <button class="btn btn-light" (click)="deleteProduct(productForm.get('id').value)">
                            <i class="bi bi-trash"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  } @else {
                    <ng-container [formGroupName]="$index">
                      <tr>
                        <td class="col-md-2">
                          <input type="text" name="name" class="form-control" formControlName="name" />
                          @if (productForm.get('name').invalid && productForm.get('name').touched) {
                            <div class="invalid-feedback">
                              {{ 'required_name' | translate }}
                            </div>
                          }
                        </td>
                        <td class="col-md-5">
                          <input type="text" name="description" class="form-control" formControlName="description" />
                        </td>
                        <td class="col-md-2">
                          <input type="number" name="price" class="form-control" formControlName="price" />
                          @if (productForm.get('price').invalid && productForm.get('price').touched) {
                            <div class="invalid-feedback">
                              {{ 'required_price' | translate }}
                            </div>
                          }
                        </td>
                        <td class="col-md-3">
                          <div class="d-inline-block float-end">
                            <button class="btn btn-success me-1" (click)="saveEdit($index)">
                              <i class="bi bi-check-lg"></i>
                            </button>
                            <button class="btn btn-danger" (click)="cancelEdit($index)">
                              <i class="bi bi-x-lg"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                  }
                }
              </ng-container>
            </ng-container>
          </tbody>
        </table>
        <ngb-pagination
          [collectionSize]="collectionSize"
          [(page)]="page"
          [pageSize]="pageSize"
          (pageChange)="pageChange($event)"
        ></ngb-pagination>
      </div>
    </div>
  </div>
</div>
